exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".selector-2heQc {\n  margin-bottom: 30px;\n}\n.selector-2heQc label {\n  float: left;\n  font-weight: bold;\n  margin-right: 15px;\n}", ""]);

// Exports
exports.locals = {
	"selector": "selector-2heQc"
};